import React, { useEffect, useState } from 'react'
import CMS from '../../../components/cms/CMS'
import PageBanner from '../../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchMenuGroupGet } from '../../../redux/slices/menuGroupGetSlice'
import CrudMenu from './CrudMenu'
import { fetchMenuGetAllByGroup } from '../../../redux/slices/menuGetAllByGroupSlice'
import { fetchMenuSort } from '../../../redux/slices/menuSortSlice'
import { fetchMenuDelete } from '../../../redux/slices/menuDeleteSlice'
import { SortableList } from '../../../components/form/SortedBy'

const MenusPage = () => {
    const [modal, setModal] = useState(false)
    const [changed, setChanged] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const menu = useSelector((state) => state.menuGroupGet.data)
    const lang = useSelector((state) => state.lang.lang)
    const status = useSelector((state) => state.menuGetAllByGroup.status)
    const menusByGroup = useSelector((state) => state.menuGetAllByGroup.data)
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const { id } = useParams()

    const getData = async () => {
        await dispatch(fetchMenuGetAllByGroup({ id: id }))
        await dispatch(fetchMenuGroupGet({ id: id }))
    }

    const deleteData = async (id) => {
        await dispatch(fetchMenuDelete({ id: id }))
        getData()
    }

    const handleSorted = (newList) => {
        menusByGroup.forEach(async (oldItem, oldIndex) => {
            const newIndex = newList.findIndex(item => item.id === oldItem.id);
            await dispatch(fetchMenuSort({ id: oldItem.id, sort: newIndex + 1 }))
            setChanged(true)
            getData()
        });
    };

    useEffect(() => {
        getData()
    }, [dispatch, id, changed])

    return (
        <CMS>
            {
                menu ? <>
                    <PageBanner
                        modal={modal}
                        setModal={setModal}
                        title={menu?.title[lang]}
                        description={t("menu_management_desct")}
                        buttonText={t("add_menu")}
                    />

                    {status === "succeeded" ?
                        <SortableList
                            setModal={setModal}
                            list={menusByGroup ? [...menusByGroup].sort((a, b) => a.sort - b.sort) : []}
                            onChange={handleSorted}
                            setChanged={setChanged}
                            deleteData={deleteData}
                            setSelectedItem={setSelectedItem}
                        /> : null
                    }

                    <CrudMenu
                        showMenu={modal}
                        setShowMenu={setModal}
                        setChanged={setChanged}
                        setSelectedItem={setSelectedItem}
                        lang={lang}
                        id={id}
                        selectedItem={selectedItem}
                        t={t}
                    />
                </> : null
            }
        </CMS>
    )
}

export default MenusPage
